import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { toInteger, padNumber } from '@ng-bootstrap/ng-bootstrap/util/util';
import { isNumber } from 'util';

@Injectable()
export class DateFormatService  extends NgbDateParserFormatter{

  // parse(value: string): NgbDateStruct {
  //   if (value) {
  //     const dateParts = value.trim().split('/');
  //     if (dateParts.length === 1 && isNumber(dateParts[0])) {
  //       return {day: toInteger(dateParts[0]), month: null, year: null};
  //     } else if (dateParts.length === 2 && isNumber(dateParts[0]) && isNumber(dateParts[1])) {
  //       return {day: toInteger(dateParts[0]), month: toInteger(dateParts[1]), year: null};
  //     } else if (dateParts.length === 3 && isNumber(dateParts[0]) && isNumber(dateParts[1]) && isNumber(dateParts[2])) {
  //       return {day: toInteger(dateParts[0]), month: toInteger(dateParts[1]), year: toInteger(dateParts[2])};
  //     }
  //   }
  //   return null;
  // }

  parse(value: string): NgbDateStruct {

    if (value) {
      const dateParts = value.trim().split('-');
      if (dateParts.length === 1 && isNumber(toInteger(dateParts[0]))) {
        return {year: toInteger(dateParts[0]), month: null, day: null};
      } else if (dateParts.length === 2 && isNumber(toInteger(dateParts[0])) && isNumber(toInteger(dateParts[1]))) {
        return {year: toInteger(dateParts[0]), month: toInteger(dateParts[1]), day: null};
      } else if (dateParts.length === 3 && isNumber(toInteger(dateParts[0])) && isNumber(toInteger(dateParts[1])) && isNumber(toInteger(dateParts[2]))) {
        return {year: toInteger(dateParts[0]), month: toInteger(dateParts[1]), day: toInteger(dateParts[2])};
      }
    }
    return null;
  }
  
  // format(date: NgbDateStruct): string {
  //   return date ?
  //   `${isNumber(date.day) ? padNumber(date.day) : ''}/${isNumber(date.month) ? padNumber(date.month) : ''}/${date.year}` :
  //   '';
  // }

  format(date: NgbDateStruct): string {
    return date ?
    `${date.year}-${isNumber(date.month) ? padNumber(date.month) : ''}-${isNumber(date.day) ? padNumber(date.day) : ''}` :
    '';
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/date/date-format.service.ts